module.exports = __webpack_public_path__ + "static/img/facebook_ads_masterclass_1200x628-01.acdd8e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook_ads_masterclass_1200x628-01.png
// module id = XP2R
// module chunks = 1